(function (app) {

    var OurPay = Backbone.Model.extend({
        defaults: {
            Amount: 0,
            AgreedWithTerms: null,
            TermsAndConditions: 1,
            ShowExtraMessage: false
        },

        initialize: function () {

            _.bindAll(this, '_update');

            app.checkout.orderXhr.done(this._update);

            app.checkout.onUpdate(this._update);

            app.models.currentMethod.on('change:CurrentMethod', _.bind(function () {
                this.trigger('update', this);
            }, this));


            app.Braintree.onSetupDone(_.bind(this._onBTSetupDone, this));
        },

        _update: function (data) {
            var agreedWithTermsState = this.get('AgreedWithTerms');

            data = data.MyPayDetails || {};
            if (agreedWithTermsState == null) {
                data.AgreedWithTerms = data.TermsAndConditions === 2;
            } else {
                data.AgreedWithTerms = agreedWithTermsState;
            }
            this.set(_.extend({}, this.defaults, data));
            this.set('ShowExtraMessage', data.ShowExtraMessage);
            this.set('OurpayMode', data.OurpayMode);

            this.trigger('update', this);
        },

        showExtraMessage: function () {
            return this.get('ShowExtraMessage');
        },

        ourpayMode: function () {
            return this.get('OurpayMode');
        },

        pay: function (IsStripeEnabled) {
            if (!this._canPay) {
                return;
            }

            if (this.get('TermsAndConditions') !== 0 && !this.get('AgreedWithTerms')) {
                kos.dialog.popup({ title: GetPageTemplate('_OurPayTCValidationFailed') });
                return;
            }

            var method = app.models.payment.getCurrentPaymentMethod();

            if (!method || method.IsNew) {
                if (IsStripeEnabled) {
                    app.models.payment.payNewStripeOurPay();
                } else {
                    app.models.payment.payNewOurPay(_.bind(this._onPayError, this));
                }
            } else {
                if (IsStripeEnabled && method.ProviderType.toLowerCase() === 'stripe') {
                    app.models.payment.payStripeOurPay(method);
                } else {
                    app.models.payment.payOurPay(method, _.bind(this._onPayError, this));
                }
            }
        },

        isEnabled: function () {
            var method = app.models.payment.getCurrentPaymentMethod();
            return !this._isDisabledByAppSetting()
                && !this._isDisabledByResponse()
                && !this.isRejectedByUntrusted()
                && (!method || method.IsNew || method.Type === CheckoutSettings.PaymentSystemType.braintree || method.Type === CheckoutSettings.PaymentSystemType.stripe);
        },

        isRejected: function () {
            return !this.get('Enabled') && this.get('ReasonCode');
        },

        isRejectedByOutOfRange: function () {
            return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.outOfRange;
        },

        isRejectedByExceededDebtLimit: function () {
            return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.exceededDebtLimit;
        },

        isRejectedByUntrusted: function () {
            return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.untrusted;
        },

        isRejectedByInvalidPaymentMethodFromResponse: function () {
            return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.invalidPaymentMethod;
        },

        isRejectedByInvalidPaymentMethod: function () {
            var currentMethod = app.models.payment.getCurrentPaymentMethod();
            var myPayWithPayPalEnabled = CheckoutSettings.getBasketSettings().MyPayWithPayPalEnabled;
            if (currentMethod && !currentMethod.IsNew) {
                var currentType = currentMethod.OrderPaymentType;
                return currentType !== CheckoutSettings.OrderPaymentType.BrainTree &&
                    currentType !== CheckoutSettings.OrderPaymentType.Stripe &&
                    (!myPayWithPayPalEnabled || currentType !== CheckoutSettings.OrderPaymentType.BrainTreePayPal);
            } else {
                return false;
            }
        },

        _isDisabledByResponse: function () {
            return !this.get('Enabled') && !this.get('ReasonCode');
        },

        _isDisabledByAppSetting: function () {
            return !CheckoutSettings.getBasketSettings().MyPayEnabled;
        },

        displayAlone: function () {
            //if (!this._isShowAllButtons && app.models.currentMethod.get('LastPaymentMethodType') === 'OurPay' && this.isEnabled() && this.get('Enabled')) {
            //    var currentMethod = app.models.currentMethod.getCurrentMethod();
            //    var currentToken = currentMethod && currentMethod.Token;
            //    var lastPaidToken = app.models.currentMethod.get('LastPaidToken');
            //    return lastPaidToken && lastPaidToken === currentToken;
            //}
            return false;
        },

        is3DsRequired: function () {
            return this.get('IsOurPayThreeDSecureRequired');
        },

        set3DsRequired: function () {
            return this.set('IsOurPayThreeDSecureRequired', true);
        },

        getAmount: function () {
            return this.get('Amount');
        },

        setShowAllButtons: function (isShowAllButtons) {
            this._isShowAllButtons = isShowAllButtons;
        },

        _onPayError: function (data) {
            var errorMessage = data.Value && data.Value.errorMessage,
                rejectionCode = data.Value && data.Value.rejectionCode;

            rejectionCode &&
                this._update({
                    ReasonCode: rejectionCode,
                    Enabled: false
                });

            this.trigger('payError', errorMessage, rejectionCode);

            app.checkout.update_checkout();
        },

        _onBTSetupDone: function () {
            this._canPay = true;
            this.trigger('braintreeSetupDone', this);
        }
    });


    app.models = _.extend({ ourpay: new OurPay() }, app.models);
})(app);